import _local_cacheInvalidate from '@/client/exchanges/cacheExchange/mutation/_local_cacheInvalidate';
import accept_invite_entry from '@/client/exchanges/cacheExchange/mutation/accept_invite_entry';
import delete_badge from '@/client/exchanges/cacheExchange/mutation/delete_badge';
import delete_badge_assignee from '@/client/exchanges/cacheExchange/mutation/delete_badge_assignee';
import delete_badge_assignee_attribute from '@/client/exchanges/cacheExchange/mutation/delete_badge_assignee_attribute';
import delete_badge_assignee_attribute_by_pk from '@/client/exchanges/cacheExchange/mutation/delete_badge_assignee_attribute_by_pk';
import delete_badge_assignee_by_pk from '@/client/exchanges/cacheExchange/mutation/delete_badge_assignee_by_pk';
import delete_badge_by_pk from '@/client/exchanges/cacheExchange/mutation/delete_badge_by_pk';
import delete_event_by_pk from '@/client/exchanges/cacheExchange/mutation/delete_event_by_pk';
import delete_event_person from '@/client/exchanges/cacheExchange/mutation/delete_event_person';
import delete_event_person_by_pk from '@/client/exchanges/cacheExchange/mutation/delete_event_person_by_pk';
import delete_event_team from '@/client/exchanges/cacheExchange/mutation/delete_event_team';
import delete_event_team_by_pk from '@/client/exchanges/cacheExchange/mutation/delete_event_team_by_pk';
import delete_message_reaction_by_pk from '@/client/exchanges/cacheExchange/mutation/delete_message_reaction_by_pk';
import delete_person_manager from '@/client/exchanges/cacheExchange/mutation/delete_person_manager';
import delete_person_team from '@/client/exchanges/cacheExchange/mutation/delete_person_team';
import delete_person_team_by_pk from '@/client/exchanges/cacheExchange/mutation/delete_person_team_by_pk';
import delete_team_by_pk from '@/client/exchanges/cacheExchange/mutation/delete_team_by_pk';
import insert_badge from '@/client/exchanges/cacheExchange/mutation/insert_badge';
import insert_badge_assignee from '@/client/exchanges/cacheExchange/mutation/insert_badge_assignee';
import insert_badge_assignee_attribute from '@/client/exchanges/cacheExchange/mutation/insert_badge_assignee_attribute';
import insert_badge_assignee_attribute_one from '@/client/exchanges/cacheExchange/mutation/insert_badge_assignee_attribute_one';
import insert_badge_assignee_one from '@/client/exchanges/cacheExchange/mutation/insert_badge_assignee_one';
import insert_badge_one from '@/client/exchanges/cacheExchange/mutation/insert_badge_one';
import insert_chat_person_preference_one from '@/client/exchanges/cacheExchange/mutation/insert_chat_person_preference_one';
import insert_event from '@/client/exchanges/cacheExchange/mutation/insert_event';
import insert_event_one from '@/client/exchanges/cacheExchange/mutation/insert_event_one';
import insert_event_person from '@/client/exchanges/cacheExchange/mutation/insert_event_person';
import insert_event_person_one from '@/client/exchanges/cacheExchange/mutation/insert_event_person_one';
import insert_event_team from '@/client/exchanges/cacheExchange/mutation/insert_event_team';
import insert_event_team_management from '@/client/exchanges/cacheExchange/mutation/insert_event_team_management';
import insert_event_team_management_one from '@/client/exchanges/cacheExchange/mutation/insert_event_team_management_one';
import insert_event_team_one from '@/client/exchanges/cacheExchange/mutation/insert_event_team_one';
import insert_message_one from '@/client/exchanges/cacheExchange/mutation/insert_message_one';
import insert_message_reaction_one from '@/client/exchanges/cacheExchange/mutation/insert_message_reaction_one';
import insert_person_manager from '@/client/exchanges/cacheExchange/mutation/insert_person_manager';
import insert_person_team from '@/client/exchanges/cacheExchange/mutation/insert_person_team';
import insert_person_team_enrollment from '@/client/exchanges/cacheExchange/mutation/insert_person_team_enrollment';
import insert_person_team_enrollment_one from '@/client/exchanges/cacheExchange/mutation/insert_person_team_enrollment_one';
import insert_person_team_one from '@/client/exchanges/cacheExchange/mutation/insert_person_team_one';
import insert_rsvp_one from '@/client/exchanges/cacheExchange/mutation/insert_rsvp_one';
import insert_team from '@/client/exchanges/cacheExchange/mutation/insert_team';
import insert_team_one from '@/client/exchanges/cacheExchange/mutation/insert_team_one';
import update_badge from '@/client/exchanges/cacheExchange/mutation/update_badge';
import update_badge_assignee from '@/client/exchanges/cacheExchange/mutation/update_badge_assignee';
import update_badge_assignee_attribute from '@/client/exchanges/cacheExchange/mutation/update_badge_assignee_attribute';
import update_badge_assignee_attribute_by_pk from '@/client/exchanges/cacheExchange/mutation/update_badge_assignee_attribute_by_pk';
import update_badge_assignee_by_pk from '@/client/exchanges/cacheExchange/mutation/update_badge_assignee_by_pk';
import update_badge_by_pk from '@/client/exchanges/cacheExchange/mutation/update_badge_by_pk';
import update_event from '@/client/exchanges/cacheExchange/mutation/update_event';
import update_event_by_pk from '@/client/exchanges/cacheExchange/mutation/update_event_by_pk';
import update_event_many from '@/client/exchanges/cacheExchange/mutation/update_event_many';
import update_event_person from '@/client/exchanges/cacheExchange/mutation/update_event_person';
import update_event_person_by_pk from '@/client/exchanges/cacheExchange/mutation/update_event_person_by_pk';
import update_event_person_many from '@/client/exchanges/cacheExchange/mutation/update_event_person_many';
import update_event_person_member_type from '@/client/exchanges/cacheExchange/mutation/update_event_person_member_type';
import update_event_person_member_type_many from '@/client/exchanges/cacheExchange/mutation/update_event_person_member_type_many';
import update_event_team from '@/client/exchanges/cacheExchange/mutation/update_event_team';
import update_event_team_by_pk from '@/client/exchanges/cacheExchange/mutation/update_event_team_by_pk';
import update_event_team_management from '@/client/exchanges/cacheExchange/mutation/update_event_team_management';
import update_event_team_management_many from '@/client/exchanges/cacheExchange/mutation/update_event_team_management_many';
import update_event_team_many from '@/client/exchanges/cacheExchange/mutation/update_event_team_many';
import update_person from '@/client/exchanges/cacheExchange/mutation/update_person';
import update_person_by_pk from '@/client/exchanges/cacheExchange/mutation/update_person_by_pk';
import update_person_many from '@/client/exchanges/cacheExchange/mutation/update_person_many';
import update_person_team from '@/client/exchanges/cacheExchange/mutation/update_person_team';
import update_person_team_by_pk from '@/client/exchanges/cacheExchange/mutation/update_person_team_by_pk';
import update_person_team_many from '@/client/exchanges/cacheExchange/mutation/update_person_team_many';
import update_person_team_member_type_update from '@/client/exchanges/cacheExchange/mutation/update_person_team_member_type_update';
import update_team_by_pk from '@/client/exchanges/cacheExchange/mutation/update_team_by_pk';
import transfer_organization from './transfer_organization';
import transfer_team from './transfer_team';

const Mutation = {
  insert_event_team_management,
  insert_event_team_management_one,
  update_event_team_management,
  update_event_team_management_many,

  accept_invite_entry,
  delete_badge,
  delete_badge_assignee,
  delete_badge_assignee_attribute,
  delete_badge_assignee_attribute_by_pk,
  delete_badge_assignee_by_pk,
  delete_badge_by_pk,
  delete_event_by_pk,
  delete_event_person,
  delete_event_person_by_pk,
  delete_event_team,
  delete_event_team_by_pk,
  delete_message_reaction_by_pk,
  delete_person_manager,
  delete_person_team,
  delete_person_team_by_pk,
  delete_team_by_pk,
  insert_badge,
  insert_badge_assignee,
  insert_badge_assignee_attribute,
  insert_badge_assignee_attribute_one,
  insert_badge_assignee_one,
  insert_badge_one,
  insert_chat_person_preference_one,
  insert_event,
  insert_event_one,
  insert_event_person,
  insert_event_person_one,
  insert_event_team,
  insert_event_team_one,
  insert_message_one,
  insert_message_reaction_one,
  insert_person_manager,
  insert_person_team,
  insert_person_team_enrollment,
  insert_person_team_one,
  insert_person_team_enrollment_one,
  insert_rsvp_one,
  insert_team,
  insert_team_one,
  transfer_team,
  transfer_organization,
  update_badge,
  update_badge_assignee,
  update_badge_assignee_attribute,
  update_badge_assignee_attribute_by_pk,
  update_badge_assignee_by_pk,
  update_badge_by_pk,
  update_event,
  update_event_by_pk,
  update_event_many,
  update_event_person,
  update_event_person_by_pk,
  update_event_person_many,
  update_event_person_member_type,
  update_event_person_member_type_many,
  update_event_team,
  update_event_team_by_pk,
  update_event_team_many,
  update_person,
  update_person_by_pk,
  update_person_many,
  update_person_team,
  update_person_team_by_pk,
  update_person_team_many,
  update_person_team_member_type_update,
  update_team_by_pk,
  _local_cacheInvalidate,
};

export default Mutation;
